const getOrganizationColors = (organization?: string) => {
  switch (organization) {
    case "Comcast":
      return ["#FCCC14", "#FF7112", "#EF1541", "#FF01E8", "#6E55DC", "#069DE0", "#00DABD", "#05AC3F", "#1d1d1b", "#ffffff"];
    case "RTX":
      return ["#000000", "#ffffff", "#D9D9D6", "#B1B3B3", "#63666A"];
    case "Synopsys":
    case "Synopsys Private Workspace":
      return ["#000000", "#ffffff", "#5A2A82", "#7E45AF", "#0081FE", "#00A5A8", "#79A133", "#26874D", "#FDB71A", "#E37820"];
    case "Target":
      return ["#CC0000", "#333333", "#ffffff"];
    default:
      return [];
  }
};

export default getOrganizationColors;
